import { createApp } from 'vue'
import App from './App.vue'
import PatientIdentityFields from './components/PatientIdentityFields.vue'
import PatientNationalityField from './components/PatientNationalityField.vue'
import router from './router'
import store from './store'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';

import languageBr from './assets/pt-br'
import { lockPageZoom } from './helpers/lockPageZoom'

lockPageZoom()

createApp(App)
    .component('PatientIdentityFields', PatientIdentityFields)
    .component('PatientNationalityField', PatientNationalityField)
    .use(store)
    .use(router)
    .use(Toast)
    .use(PrimeVue, {
        locale: languageBr["pt-br"],
        zIndex: {
            modal: 1056,        //dialog, sidebar
            overlay: 1056,      //dropdown, overlaypanel
            menu: 1056,         //overlay menus
            tooltip: 1056       //tooltip
        }
    })
    .mount('#kt_body')
